const camelCase = function(str){
    let arr = str.split('-');
    arr = arr.map((s, i)=>{
        if (i>0){
            const c = [...s];
            c[0] = c[0].toUpperCase();
            return c.join('');
        }
        return s;
    });
    return arr.join('');
}
function _setAttribute(e, k, v){
    const _k = k.toLowerCase();
    if (_k === 'text'){
        e.textContent = v;
    }else if (_k === 'html'){
        e.innerHTML = v;
    }else{
        e.setAttribute(k, v);
    }
}
function _getAttribute(e, k){
    const _k = k.toLowerCase();
    if (_k === 'text'){
        return e.innerText || e.textContent || '';
    }else if (_k === 'html'){
        return e.innerHTML || '';
    }else if (_k === 'value'){
        switch (e.tagName.toString().toLowerCase()){
            case 'select':
                return e.options[e.selectedIndex].value;
            default:
                return e.value;
        }
    }
    return e.getAttribute(k);
}

const dom = (tag, options)=>{
    const node = document.createElement(tag);
    if (options){
        Object.keys(options).forEach((key)=>{
            _setAttribute(node, key, options[key]);
        })
    }
    return node;
}
dom.el = (selector)=>{
    return document.querySelector(selector);
}
dom.els = (selector)=>{
    return document.querySelectorAll(selector);
}
dom.txtSize = function (text, styles) {
    const tmpSpan = dom("span").set('text', text).setStyles(styles).inject(document.body);
    var size = tmpSpan.getSize();
    tmpSpan.destroy();
    return size;
};

var inserters = {

    before: function(context, element){
        var parent = element.parentNode;
        if (parent) parent.insertBefore(context, element);
    },

    after: function(context, element){
        var parent = element.parentNode;
        if (parent) parent.insertBefore(context, element.nextSibling);
    },

    bottom: function(context, element){
        element.appendChild(context);
    },

    top: function(context, element){
        element.insertBefore(context, element.firstChild);
    }

};

if (Element){
    function styleNumber(element, style){
        return element.getStyle(style).toInt() || 0;
    }
    function topBorder(element){
        return styleNumber(element, 'border-top-width');
    }
    function leftBorder(element){
        return styleNumber(element, 'border-left-width');
    }
    function isBody(element){
        return !element.tagName || (/^(?:body|html)$/i).test(element.tagName);
    }
    function isHtml(element){
        return (/html/i).test(element.tagName);
    }

    Object.assign(Element.prototype, {
        el: function(selector){
            return this.querySelector(selector);
        },
        els: function(selector){
            return this.querySelectorAll(selector);
        },
        addClass: function(cls){
            var className = this.getAttribute('class');
            var classes = (className) ? className.split(/\s+/g) : [];
            if (classes.indexOf(cls)===-1){
                classes.push(cls);
                this.setAttribute("class", classes.join(' '));
            }
            return this;
        },
        removeClass: function(cls){
            var className = this.getAttribute('class');
            var classes = (className) ? className.split(/\s+/g) : [];
            const i = classes.indexOf(cls);
            if (i!==-1){
                classes.splice(i, 1);
                this.setAttribute('class', classes.join(' '));
            }
            return this;
        },
        hasClass: function(cls){
            var className = this.getAttribute('class');
            var classes = (className) ? className.split(/\s+/g) : [];
            return classes.indexOf(cls)!==-1;
        },
        set: function(key, value){
            if (typeof key === 'object'){
                Object.keys(key).forEach((k)=>{
                    _setAttribute(this, k, key[k]);
                });
            }else{
                _setAttribute(this, key, value);
            }
            return this;
        },
        get: function(key){
            return _getAttribute(this, key);
        },
        setStyle: function(key, value){
            if (typeof key === 'object'){
                Object.keys(key).forEach((k)=>{
                    this.style[camelCase(k)] = key[k];
                });
            }else{
                this.style[camelCase(key)] = value;
            }
            return this;
        },
        setStyles: function(styles){
            Object.keys(styles).forEach((k)=>{
                this.style[camelCase(k)] = styles[k];
            });
            return this;
        },
        getStyle: function(key){
            const property = camelCase(key);
            let result = this.style[property];
            if (!result){
                const style = window.getComputedStyle(this);
                result = style[property];
            }
            return result;
        },
        getStyles: function(){
            var r = {};
            const args = [...arguments];
            args.forEach((arg)=>{
                r[arg] = this.getStyle(arg);
            });
            return r
        },
        inject: function(el, position){
            const ps = {
                'top': 'afterbegin',
                'bottom': 'beforeend',
                'before': 'beforebegin',
                'after': 'afterend'
            }
            let p = ps[position] || position;
            if (el.insertAdjacentElement){
                el.insertAdjacentElement(p||'beforeend' , this);
            }else{
                inserters[position || 'bottom'](this, el);
            }

            return this;
        },
        destroy: function(){
            if (Element.prototype.hasOwnProperty('remove')){
                this.remove();
            }else{
                if (this.parentNode) this.parentNode.removeChild(this);
            }
        },
        addEvent: function(type, listener, options){
            this.addEventListener(type, listener, options);
        },
        removeEvent: function(type, listener, options){
            this.removeEventListener(type, listener, options);
        },
        show: function(){
            const ds = this.style.display;
            if (ds==='none'){
                this.setStyle('display', (this.dataset['storeDisplay'] || 'block'));
            }
        },
        hide: function(){
            const ds = this.style.display;
            if (ds!=='none'){
                this.dataset['storeDisplay'] = ds;
                this.setStyle('display', 'none');
            }
        },
        empty: function(){
            while(this.children.length) this.children[0].destroy();
        },
        appendHTML: function(html){
            this.insertAdjacentHTML('beforeend', html);
        },
        getParent: function(tag){
            var node = this.parentElement;
            if (tag) while (node && !node.matches(tag)) node = node.parentElement;
            return node;
        },
        getSize: function(){
            if (isHtml(this)){
                return {x: this.clientWidth, y: this.clientHeight};
            }else{
                const rect = this.getBoundingClientRect();
                return {x: rect.width, y: rect.height};
            }
        },
        getFirst: function(){
            return this.firstElementChild;
        },
        getLast: function(){
            return this.lastElementChild;
        },
        getNext: function(){
            return this.nextElementSibling;
        },
        getPrevious: function(){
            return this.previousElementSibling;
        },

        dispose: function(){
            return (this.parentNode) ? this.parentNode.removeChild(this) : this;
        },
        matches: Element.prototype.matches ||
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function(s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {}
                return i > -1;
            },
        store: function(key, value){
            this[key] = value;
            return this;
        },
        retrieve: function(key, dflt){
            let prop = this[key];
            if (dflt != null && prop == null) prop = this[key] = dflt;
            return prop != null ? prop : null;
        },
        eliminate: function(key){
            delete this[key];
            return this;
        },
        appendText: function(text, where){
            const ps = {
                'top': 'afterbegin',
                'bottom': 'beforeend',
                'before': 'beforebegin',
                'after': 'afterend'
            }
            let p = ps[where] || where;
            this.insertAdjacentText(p||'beforeend', text);
        },
        getScrollSize: function(){
            if ((/^(?:body|html)$/i).test(this.tagName)){
                const doc = document.documentElement, body = document.body;
                return {x: Math.max(doc.scrollWidth, body.scrollWidth), y: Math.max(doc.scrollHeight, body.scrollHeight)};
            }
            return {x: this.scrollWidth, y: this.scrollHeight};
        },
        getScroll: function(){
            return {x: this.scrollLeft, y: this.scrollTop};
        },
        getScrolls: function(){
            let element = this.parentNode, position = {x: 0, y: 0};
            while (element && !isBody(element)){
                position.x += element.scrollLeft;
                position.y += element.scrollTop;
                element = element.parentNode;
            }
            return position;
        },
        getPosition: function(relative){
            if (relative==window) relative = document.documentElement;
            const bound = this.getBoundingClientRect(),
                html = document.documentElement,
                htmlScroll = html.getScroll(),
                elemScrolls = this.getScrolls(),
                isFixed = (this.getStyle('position') === 'fixed');

            const offset = {
                x: bound.left + elemScrolls.x + ((isFixed) ? 0 : htmlScroll.x) - html.clientLeft,
                y: bound.top + elemScrolls.y + ((isFixed) ? 0 : htmlScroll.y) - html.clientTop
            };
            const scroll = this.getScrolls();

            const position = {
                x: offset.x - scroll.x,
                y: offset.y - scroll.y
            };


            if (relative){
                const relativePosition = relative.getPosition();
                return {x: position.x - relativePosition.x - leftBorder(relative), y: position.y - relativePosition.y - topBorder(relative)};
            }
            return position;
        },
        getParentSrcollNode: function () {
            let node = this.getParent();
            while (node && (node.getScrollSize().y - 2 <= node.getSize().y || (node.getStyle("overflow") !== "auto" && node.getStyle("overflow-y") !== "auto"))) {
                node = node.getParent();
            }
            return node || document.documentElement;
        },
    });
}
window.getScroll = function(){
    const node = document.documentElement;
    return {x: node.scrollLeft, y: node.scrollTop};
}
window.getPosition = function(relative){
    return document.documentElement.getPosition(relative);
}

var cloneOf = function(item){
    if (Array.isArray(item)) return item.clone();
    if (!item) return item;
    if ((typeof item) === 'object') return Object.clone(item);
    return item;
};

if (Array){
    Object.assign(Array.prototype, {
        hexToRgb: function(array){
            if (this.length != 3) return null;
            var rgb = this.map(function(value){
                if (value.length == 1) value += value;
                return parseInt(value, 16);
            });
            return (array) ? rgb : 'rgb(' + rgb + ')';
        },

        rgbToHex: function(array){
            if (this.length < 3) return null;
            if (this.length == 4 && this[3] == 0 && !array) return 'transparent';
            var hex = [];
            for (var i = 0; i < 3; i++){
                var bit = (this[i] - 0).toString(16);
                hex.push((bit.length == 1) ? '0' + bit : bit);
            }
            return (array) ? hex : '#' + hex.join('');
        },
        clone: function(){
            var i = this.length, clone = new Array(i);
            while (i--) clone[i] = cloneOf(this[i]);
            return clone;
        }
    });
}
if (String){
    Object.assign(String.prototype, {
        toFloat: function(){
            if (!this) return NaN;
            return parseFloat(this.toString());
        },
        toInt: function(){
            if (!this) return NaN;
            return parseInt(this.toString());
        },
        capitalize: function(){
            return this.charAt(0).toUpperCase() + this.substring(1);
        },
        hexToRgb: function(array){
            var hex = String(this).match(/^#?(\w{1,2})(\w{1,2})(\w{1,2})$/);
            return (hex) ? hex.slice(1).hexToRgb(array) : null;
        },
        rgbToHex: function(array){
            var rgb = String(this).match(/\d{1,3}/g);
            return (rgb) ? rgb.rgbToHex(array) : null;
        },
        camelCase: function(){
            return camelCase(this);
        },
        getHtmlText: function(){
            var div = dom("div", { "html": this });
            var text = div.get("text");
            div.destroy();
            return text;
        },
    });
}
if (Node){
    Object.assign(Node.prototype, {
        half2full: function(){
            let node = this;
            while (node){
                if (node.nodeType===3){
                    node.nodeValue = node.nodeValue.replace(/\x20/g, "　");
                }else if (node.nodeType===8){
                    //nothing
                }else{
                    node = node.firstChild;
                    if (node) node.half2full();
                }
                if (node) node = node.nextSibling;
            }
            return this;
        }
    });
}
if (NodeList){
    Object.assign(NodeList.prototype, {
        forEach: NodeList.prototype.forEach ||
            function(callback, thisArg){
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            },
        setStyles: function(styles){
            this.forEach((node)=>{
                if (node.nodeType === Node.ELEMENT_NODE){
                    node.setStyles(styles);
                }
            });
        },
        setStyle: function(key, value){
            this.forEach((node)=>{
                if (node.nodeType === Node.ELEMENT_NODE){
                    node.setStyle(key, value);
                }
            });
        },
        addClass: function(cls){
            this.forEach((node)=>{
                if (node.nodeType === Node.ELEMENT_NODE){
                    node.addClass(cls);
                }
            });
        },
        removeClass: function(cls){
            this.forEach((node)=>{
                if (node.nodeType === Node.ELEMENT_NODE){
                    node.removeClass(cls);
                }
            });
        },
        addEvent: function(type, listener, options){
            this.forEach((node)=>{
                if (node.nodeType === Node.ELEMENT_NODE){
                    node.addEvent(type, listener, options);
                }
            });
        },
        removeEvent: function(type, listener, options){
            this.forEach((node)=>{
                if (node.nodeType === Node.ELEMENT_NODE){
                    node.removeEvent(type, listener, options);
                }
            });
        },
    });
}

Object.clone = function(object){
    var clone = {};
    for (var key in object) clone[key] = cloneOf(object[key]);
    return clone;
};
export default dom;

